// extracted by css-extract-rspack-plugin
export default {"tournament-view":"a9DfDXuh","tournament-view__canvas":"mYISRSXE","tournament-view__status":"uX_jeTNc","tournament-view__status--error":"LYSbucp5"};